<template>
    <div>
            <!-- <iframe src="https://tb.53kf.com/code/wx/c8a12b38134caf46a69c75534ba9e4011/1+" style="width: 100%; height: 650px;border: none;"></iframe> -->
    </div>
</template>
<script>
export default {
    data(){
        // (function (w, t, l, k, j, g, s) {
        //     w[k] = w[k] || function () {
        //         (w[k][j] = w[k][j] || []).push(arguments);
        //     };
        //     g = t.createElement(l),
        //         s = t.getElementsByTagName(l)[0];
        //     g.charset = 'UTF-8';
        //     g.id = 'tlkj_1587115010388';
        //     g.src = 'https://livechat.tlkj.com/sessionFrame.js?random='+ new Date().getTime();
        //     s.parentNode.insertBefore(g, s);
        //     g.onload = function () {
        //         w[k][j] && w[k][j].forEach(function(item) {
        //             w[k] && w[k].apply(null, item)
        //         });
        //         delete w[k][j];
        //     }
        // })(window, document, 'script', '_TLKJ', '_TEMP_');
        // _TLKJ('tid', 200);
        // _TLKJ('assign', {
        //     mid: 0
        // });
        // return {
        // }
    },

    mounted () {
        if(document.body.previousElementSibling.tagName.toLowerCase() == 'script' && document.body.previousElementSibling.src == 'http://kefu.easemob.com/webim/easemob.js?configId=15fca919-b918-4a78-81ae-2d635c4bf552'){
            return;
        }else {
            var scr = document.createElement("script");
            scr.src = '//kefu.easemob.com/webim/easemob.js?configId=15fca919-b918-4a78-81ae-2d635c4bf552';
            document.documentElement.insertBefore(scr, document.body);
            window.easemobim = window.easemobim || {};
            easemobim.config = {
                configId: '15fca919-b918-4a78-81ae-2d635c4bf552',
                buttonText: '联系客服',
                dialogWidth: '650px',
                dialogHeight: '650px',
                dialogPosition: { x: '50px', y: '50px' }
            };
        }
    } 
}

</script>
<style lang="less">

</style>

